import React from 'react'

import checklistbedroom from '../../assets/Guides/Bedroomguide/checklistbedroom.png'
import kingorqueenbed from  '../../assets/Guides/Bedroomguide/kingorqueenbed.png'
import bedroomfurniture from '../../assets/Guides/Bedroomguide/bedroomfurniture.png'
import bedroomheadboard from '../../assets/Guides/Bedroomguide/bedroomheadboard.png'
import bedroomwardrobe from '../../assets/Guides/Bedroomguide/bedroomwardrobe.png'
import bedsidetable from '../../assets/Guides/Bedroomguide/bedsidetable.png'
import dressingunit from '../../assets/Guides/Bedroomguide/dressingunit.png'
import tvunit from '../../assets/Guides/Bedroomguide/tvunit.png'
import studyunit from '../../assets/Guides/Bedroomguide/studyunit.png'
import loftup from '../../assets/Guides/Bedroomguide/loftup.png'
import decorwall from '../../assets/Guides/Bedroomguide/decorwall.png'
import fandesign from '../../assets/Guides/Bedroomguide/fandesign.png'
import bedroomshutter from '../../assets/Guides/Bedroomguide/bedroomshutter.png'
import bedroomdecordesign from '../../assets/Guides/Bedroomguide/bedroomdecordesign.png'
import lightsdesign from '../../assets/Guides/Bedroomguide/lightsdesign.png'

import bedroomcampaign from '../../assets/Guides/Bedroomguide/bedroomcampaign.png'
import bedroomwalldecoration from  '../../assets/Guides/Bedroomguide/bedroomwalldecoration.png'
import teenagebedroomdesign from '../../assets/Guides/Bedroomguide/teenagebedroomdesign.png'
import boysbedroomdesign from '../../assets/Guides/Bedroomguide/boysbedroomdesign.png'
import girlsbedroomdesign from '../../assets/Guides/Bedroomguide/girlsbedroomdesign.png'
import masterbedroom from '../../assets/Guides/Bedroomguide/masterbedroom.png'
import modernbedroomdesign from '../../assets/Guides/Bedroomguide/modernbedroomdesign.png'
import romanticbedroomdesign from '../../assets/Guides/Bedroomguide/romanticbedroomdesign.png'
import simplebedroomdesign from '../../assets/Guides/Bedroomguide/simplebedroomdesign.png'

import murphybeddesign from '../../assets/Guides/Bedroomguide/murphybeddesign.png'
import trundlebed from '../../assets/Guides/Bedroomguide/trundlebed.png'
import bunkbeds from '../../assets/Guides/Bedroomguide/bunkbeds.png'
import hydraulic from '../../assets/Guides/Bedroomguide/hydraulic.png'
import floorbeds from '../../assets/Guides/Bedroomguide/floorbeds.png'
import storagebeddesign from '../../assets/Guides/Bedroomguide/storagebeddesign.png'
import kingsizebed from '../../assets/Guides/Bedroomguide/kingsizebed.png'
import queensizebed from '../../assets/Guides/Bedroomguide/queensizebed.png'
import singlebeddesign from '../../assets/Guides/Bedroomguide/singlebeddesign.png'
import bookcaseheadboards from '../../assets/Guides/Bedroomguide/bookcaseheadboards.png'
import contemporaryheadboards from '../../assets/Guides/Bedroomguide/contemporaryheadboards.png'
import slatheadboards from '../../assets/Guides/Bedroomguide/slatheadboards.png'
import panelheadbords from '../../assets/Guides/Bedroomguide/panelheadbords.png'
import traditionalheadboards from '../../assets/Guides/Bedroomguide/traditionalheadboards.png'
import woodenheadboards from '../../assets/Guides/Bedroomguide/woodenheadboards.png'
import metalheadboards from '../../assets/Guides/Bedroomguide/metalheadboards.png'
import leatherheadboard from '../../assets/Guides/Bedroomguide/leatherheadboard.png'
import neutralfiber from '../../assets/Guides/Bedroomguide/neutralfiber.png'


import wardrobedesigninbedrom from '../../assets/Guides/Bedroomguide/wardrobedesigninbedrom.png'
import wardrobewithbookshelf from '../../assets/Guides/Bedroomguide/wardrobewithbookshelf.png'
import slidingdoorwardrobe from '../../assets/Guides/Bedroomguide/slidingdoorwardrobe.png'
import wardrobewithdresser from '../../assets/Guides/Bedroomguide/wardrobewithdresser.png'
import wardrobewithstudyunit from '../../assets/Guides/Bedroomguide/wardrobewithstudyunit.png'
import glassandaluminiumshutterwardrobe from '../../assets/Guides/Bedroomguide/glassandaluminiumshutterwardrobe.png'
import loftstoragewardrobe from '../../assets/Guides/Bedroomguide/loftstoragewardrobe.png'
import walkinwardrobe from '../../assets/Guides/Bedroomguide/walkinwardrobe.png'
import wardrobewithshutters from '../../assets/Guides/Bedroomguide/wardrobewithshutters.png'
import wardrobewithoutshutter from '../../assets/Guides/Bedroomguide/wardrobewithoutshutter.png'
import howtochooserightwardrobe from '../../assets/Guides/Bedroomguide/howtochooserightwardrobe.png'
import wardrobeformasterbedroom from '../../assets/Guides/Bedroomguide/wardrobeformasterbedroom.png'
import wardrobeforkids from '../../assets/Guides/Bedroomguide/wardrobeforkids.png'
import wardrobbeforguestroom from '../../assets/Guides/Bedroomguide/wardrobbeforguestroom.png'
import wardrobedesign from '../../assets/Guides/Bedroomguide/wardrobedesign1.png'



const BedroomGuide = () => {
  return (
    <div className='bedroomguide guide'>

      <h1 id='bedroom1'  style={{marginTop:"110px"}}>A Bedroom Interior Design Checklist</h1><br/>
        <p>
          interiors are like jewels in a crown that make a space shine. Furniture, wall art, cabinets, shelves, cupboards, colours and decorative pieces are must-haves for any bedroom.
          Every bedroom needs furniture, storage solutions, lighting apart from accessories like rugs, throw pillows, a good display case, a nightstand to complete the look.
        </p>
        <img src={checklistbedroom} style={{width:'100%'}} alt=''/><br/><br/><br/>

        <h4>A King Or A Queen?</h4><br/>
          <p>
              A bedroom bed is probably an essential piece of furniture you will invest in! Make sure your bed satisfies your needs in terms of safety, comfort, and design. 
              Whether you choose to opt for a classic, modern, or a rustic design, your bed will dominate the room. To give it a statement, team your bed with decorative fabrics (like silks) for some flavour and style,
              especially if you’re one to keep up with the Joneses. Upholstered beds are great for a modern look while a minimalist wooden bed is ideal if you want to play with colours, materials, and textures in the space.
          </p>
          <img src={kingorqueenbed}  style={{width:'100%'}} alt=''/><br/><br/><br/>

        <h4>Spruce Up Your Bedroom With The Right Furniture</h4><br/>
          <p>
              Bedroom furniture completes the look of a room as long as it’s not disproportionate to the entire space. A full room typically consists of a bed and a few other pieces of furniture as must-have elements.
              Pick bedroom furniture according to your age group and lifestyle. Bedroom furniture designs bring in elements of comfort and fullness to space. If your bedroom has ample space, then put a few accent pieces.
              You can place a work table in a corner and a vintage trunk at the base of the bed to amp up the aesthetics. This can also double up as storage for bed linen. A vanity table adds a feminine feel to the bedroom,
              for the woman of the house to doll up and also bring in some elegance.
          </p>
          <img src={bedroomfurniture}  style={{width:'100%'}} alt=''/><br/><br/><br/>

        <h4>Complement It With A Headboard</h4><br/>
          <p>
              No settling for boring beds now! Bedroom headboards, available in umpteen textures, patterns and colours, accessories your bed and your bedroom in ways previously unimaginable. Apart from the comfort and safety
              they provide, they also play a significant role in varying the texture of the room a little bit and not letting all of it be woody.
          </p>
          <img src={bedroomheadboard}  style={{width:'100%'}} alt=''/><br/><br/><br/>

        <h4>Choose A Wardrobe That’s Right For You</h4><br/>
          <p>
            Every bedroom needs proper storage to keep the room clutter-free and make living more comfortable. You can achieve this by adding cupboards to your master bedroom. There are tons of bedroom cupboard designs you can 
            choose from to make optimum use of your space. A floor to ceiling cupboard will maximise storage in your bedroom. Put your suitcases and strollers above the closet and clothing inside. A mirrored bedroom serves a dual
            purpose in small bedrooms. It saves space and makes the room spacious. A built-in-cabinet is easy to customise, and it looks beautiful too!
          </p>
          <img src={bedroomwardrobe}  style={{width:'100%'}} alt=''/><br/><br/><br/>

        <h4>A Well Decorated Bedside Table</h4><br/>
          <p>
            Where do you keep your watch, glasses, and phones? If your bed is the answer, then it’s time you considered a bedside table. Not only is it functional but has the potential to become a decorative piece too. A bedside table, 
            lamp atop is perfect for that night reading binge or to move around in the dark. A well-decorated bedside table changes a room’s atmosphere and brings in the sense of calm and peace. Place an indoor plant for a natural look or
            adorn it with shiny colourful stones. And if you are a stickler for functional design, then opt for bedside a table with drawers to stash away basics like keys, wallets, and documents.
          </p>
          <img src={bedsidetable} style={{width:'100%'}} alt=''/><br/><br/><br/>

        <h4>Face The Day In Style With A Smart Dressing Unit</h4><br/>
          <p>
            The kohl in your eyes or the crease in your tie – you check them all in front of your bedroom dressing table, isn’t it? You can now have your dressing table or units designed with smart features and storage solutions to blend
            in with the rest of the modular furniture in your bedroom. Also, hidden shelving and pull-out stools save space.
          </p>
          <img src={dressingunit} style={{width:'100%'}} alt=''/><br/><br/><br/>

        <h4>Gift Your Bedroom A TV Unit!</h4><br/>
          <p>
            After a long hard day of work, catching up on your favourite show or watching the news should not be something you have to do outside your bedroom. Bedroom TV units – hidden or displayed – are the perfect addition to your
            bedroom for those lazy Saturday nights to Netflix and chill.
          </p>
          <img src={tvunit} style={{width:'100%'}} alt=''/><br/><br/><br/>

        <h4>A Study Unit</h4><br/>
          <p>
            Are you a book aficionado? Or someone who likes a newspaper ready with your morning tea? If the answer is yes, then you need a bedroom study table. Design one with good lighting fixtures and comfortable smart seating and storage. 
            Study units up the ante of your bedroom and give it the persona of an intellectual.
          </p>
          <img src={studyunit} style={{width:'100%'}} alt=''/><br/><br/><br/>

        <h4>Upgrade Your Bedroom With A False Ceiling</h4><br/>
          <p>
            Adding a false ceiling to your bedroom will take it to new heights, literally! A false ceiling hides flaws and conceals wiring that makes a bedroom look neat. And for bedrooms with high ceilings, 
            false roofs reduce the height to level with the overall dimensions. There are many types of false ceiling designs. A few are:
          </p>
          <ul>
            <li>A layered tray <i>(perfect for a master bedroom)</i></li>
            <li>Wooden beams   <i>(if your flooring is wooden)</i></li>
            <li>Coffered design<i>(crisscrossing beams that form a grid-like pattern)</i></li>
          </ul><br/>

        <h4>Loft It Up!</h4><br/>
          <p>
            If you live in a tiny room, then a bedroom loft is a brilliant space-saving solution. It makes for a good sleeping area, a place for wardrobes or a space to work in thereby turning your small bedroom
            into a multipurpose space. A loft bed, or one that is at least 30 inches above the floor, adds to storage space in the bedroom. You can turn your space into an office loft- add a desk, good lighting, and a chair to get on with some work.
          </p>
          <img src={loftup} style={{width:'100%'}}  alt=''/><br/><br/><br/>

        <h4>Let Your Walls Do The Talking!</h4><br/>
          <p>
              Plain walls are passe. Bedroom wall design brings in fresh energy to a room making it a pleasure to live in. Opt for 3D wall painting designs if your wall is wide and long. You can also paint it in an aquamarine theme for a soothing vibe.
              Blue is good for restful sleep. Play with LED bulbs as it is cost-effective and adds elegance too. Or how about family portraits on your wall to conjure up a nice nostalgic feeling?
          </p>
          <img src={decorwall} style={{width:'100%'}} alt=''/><br/><br/><br/>

        <h4>Never Ignore Your Fan!</h4><br/>
          <p>
            Bedroom ceiling fans are dull accessories you need not tolerate each time you look up. With ornamental ceiling fans and hi-tech silent fan designs cropping up in the market, you can bring in a piece of art in your bedroom.
          </p>
          <img src={fandesign} style={{width:'100%'}}  alt=''/><br/><br/><br/>

        <h4>Control The Brightness With Bedroom Shutters</h4><br/>
          <p>
            As much as you need an inflow of natural light in your bedroom, controlling it is crucial, both for privacy and good sleep. Instead of curtains, that require manual effort to be put parted or drawn try blinds or shutters. 
            They are mechanically controlled and do the job just fine! 
          </p><br/>
          <ul>
            <li>Roman</li>
            <li>Duette</li>
            <li>Vertical </li>
            <li>Wooden</li>
            <li>Venetian </li>
            <li>Wooden Venetian</li>
            <li>Roller</li>
          </ul><br/>
          <img src={bedroomshutter}  style={{width:'100%'}} alt=''/><br/><br/><br/>

        <h4>Adorn Your Bedroom With The Right Decor</h4><br/>
          <p>
            The bedroom represents your traits in ways you may not have imagined! It’s your place to unwind. Keeping it simple and clean is the best bedroom decoration tip any professional will give you.
            You can adorn your bedroom with a few statement pieces to give it class and oomph. Good lighting enhances the beauty of your bedroom. So make sure to place a task light for a spot for bedtime reading. 
            Play with colours and dream away in an ebb of sea blue and bubbling white bed linen. Or add matching wallpaper for a beautiful backdrop. Does nothing compare to a serene bedroom setting?
          </p>
          <img src={bedroomdecordesign}  style={{width:'100%'}}  alt=''/><br/><br/>

          <i style={{lineHeight:'30px', fontSize:'18px', color:'#222222'}}>
          Your bedroom is a sanctum of sleep an oasis for rest and rejuvenation, and it is essential to decorate it with the right accessories. 
          These are things that are not only aesthetic but functional too to make your bedroom a well-designed space.
          </i><br/>
    {/* ***********Bedroom Interior Design Checklist end ************* */}
    
    {/* ************************************************************* */}
    <h1 id='bedroom2'>A Comprehensive Guide To Bedroom Decor</h1><br/>

      <h4>Decorative Lights For Your Bedroom</h4><br/>
        <p>
          If you love the idea of light surrounding you then this bedroom is just perfect. Bay windows for natural light during the day time, beautiful globe-shaped pendant lights with a rich copper finish and 
          a chandelier with light tubes merged with a metal frame will leave you illuminated. 
          This bedroom decor has different shades of grey inculcated throughout the room. The headboard, wallpaper, window frames, ceiling to floor wardrobe and floor mat all have a tone of a different grey.
        </p>
        <img src={lightsdesign}  style={{width:'100%'}}  alt=''/><br/><br/><br/>

      <h4>Camping 365 Days A Year</h4><br/>
        <p>
          If you have kids who love the idea of camping and wait for summer holidays to be sent away well we have some great news for you parents. With this bedroom decoration your kids will feel like they’re at camp all through the year. 
          What more could your kid want when this room has a bunk bed made of wood that resembles a treehouse? A sweet little tent at the bottom is also part of the design and that is where they can pretend to be an explorer camping in a forest hiding from a big grizzly bear.
          This bedroom has a window with a shutter that means your child can choose how much sunlight to let into the room. 
        </p>
        <img src={bedroomcampaign} style={{width:'100%'}} alt=''/><br/><br/><br/>

      <h4>It’s All In A Wall</h4><br/>
        <p>
          Would you want your wall to dull your beautiful wooden flooring bedroom, would you? Take a look at this gorgeous bedroom it gives a clear idea on how you can decorate your bedroom wall. A classic feature wall in grey with a tinge of psychedelic pattern changes the look of this bedroom.
          So just a wall can make sure your room looks fab and glamorous in no time. This bedroom has a lovely dresser with an elegant mirror with focus lights attached to it which will leave you feeling like a celebrity while dabbing on some makeup as you get ready. A petite little stool with drawers
          in white adds to this little nook.
        </p>
        <img src={bedroomwalldecoration} style={{width:'100%'}}  alt=''/><br/><br/><br/>

      <h4>Time For A Teenage Bedroom Decor Inspiration</h4><br/>
        <p>
        If you have a teenager at home who likes their space, loves to read and adores the colour blue then this teenage bedroom decor is worth checking out. Hues of blue, from dark to light, can be seen on this queen size bed from the quilt to the pillows and the throw. This is all a part of bedroom decor. 
        A lovely blue floor mat gives a calming aura to this bedroom, and the chair by the window will allow your teen to relax and read their favourite book. Bell-shaped pendant lights hang on the sides and add a pretty view to this bedroom. A headboard with a room for placing cute items or photo frames is 
        an add on to this bedroom decor
        </p>    
        <img src={teenagebedroomdesign}style={{width:'100%'}} alt=''/><br/><br/><br/>

      <h4>A Boy’s Bedroom Decor</h4><br/>
        <p>
          This boy’s bedroom decor will leave you with a touch of the city. This unique wallpaper depicts a city with high towers is a dream come true for many young boys. Boys love to laze around and play video games. It is second nature to them So if you boy has a keen eye towards the PlayStation now he has a comfortable grey bean bag to sit on. The bamboo shutters, wooden panels along with wardrobe and study add a beautiful rustic, earthy feel to this bedroom while still keeping it modern.
          Miniature side lamps added to this bedroom decor are perfect for midnight readers. 
        </p>
        <img src={boysbedroomdesign} style={{width:'100%'}} alt=''/><br/><br/><br/>

      <h4>Decor For A Girls Bedroom</h4><br/>
        <p>
          If you have a girl child you know that she is the little princess in your home. And you, as parents, will do anything to make sure her room is a safe and happy place for her to be in. Take a look at this girls bedroom decor. It has a colourful mat where she can play on and the rich will keep her warm throughout the winter.
          A white and pink striped fabric tent will give her the feeling of being a princess in a castle. A pink and white study has been integrated and behind that is colourful wallpaper that brings a splash of colour and freshness into this bedroom.
        </p>
        <img src={girlsbedroomdesign} style={{width:'100%'}} alt=''/><br/><br/><br/>

      <h4>Decor For A Master Bedroom</h4><br/>
        <p>
          Masters of the house listen up! A master bedroom decor must include a TV unit as most couples like to relax, lay back after work and watch a sitcom. This master room has a lovely hollow crystal chandelier hanging from the ceiling, making it not only a lovely light fixture but also a piece of art. At the corner of this bedroom we see  an elegant cushions console stool with a copper framed oval-shaped mirror.  A bedside lamp sits on a wooden bedside table that is apt for those who work into the night.
          A pretty picture of flowers and indoor plants with classy vases add to this bedroom decor. 
        </p>
        <img src={masterbedroom} style={{width:'100%'}} alt=''/><br/><br/><br/>

      <h4>Modern Bedroom Decor</h4><br/>
        <p>
          This modern bedroom decor is easy and looks funky too.  Cylindrical fabric pendant lights bring an urban vibe while a moodha stool brings in a pop of tradition. A medium-sized painting of a bridge in mid-air amidst the clouds makes the grey wall more alive than ever. The wooden chair brings in a rustic touch while the white leather headboard adds to the elegance of this room. 
        </p>
        <img src={modernbedroomdesign}  style={{width:'100%'}} alt=''/><br/><br/><br/>

      <h4>A Romantic Bedroom Decor Idea</h4><br/>
        <p>
          Want to keep your love life active? Check this romantic bedroom decor out. This master bedroom has tinges of red here and there to represent love. A luscious velvet headboard in deep red will set your mood on fire. A red armchair is placed at the study nook, and strips of the colour red have been included on the floor rug. Brown brings a warm, secure feeling while the white wall adds elegance to this space. The indoor plant will give you a dose of fresh air for healthy living. 
        </p>
        <img src={romanticbedroomdesign} style={{width:'100%'}} alt=''/><br/><br/><br/>

      <h4>Simplicity Comes With A Simple Bedroom Decor</h4><br/>
        <p>
          If you like to keep things simple and neat but want just the right amount of decor, then this simple bedroom decor might please you. Paintings can make walls alive with minimal effort. So don’t hesitate to put some up. Adding plants in your room will give your room a sense of freshness so don’t miss out on that either. 
          A simple floor rug can bring in a rather sophisticated look to a bedroom so do choose a light coloured one.
        </p>
        <img src={simplebedroomdesign}  style={{width:'100%'}} alt=''/><br/><br/><br/>
      {/* ***********A Comprehensive Guide To Bedroom Decor--------end */}




      {/* ************************************************************ */}
      <h1 id='bedroom3'> Everything You Must Know About Different Types Of Beds</h1><br/>

        <i style={{fontSize:'18px',color:'#222222',lineHeight:'30px'}}>
          Time to get to know your beds better! We at DesignCafe have come up with a guide on everything you must know about types of beds.
        </i><br/><br/>
        <p>
          Let’s start with a little bit of the unexpected history of beds. Did you know that 23-25 million years ago before humans walked on earth, apes were the first creators of beds? They would create a surface out of the land and raw material with a wooden pillow. Fascinating, isn’t it? As centuries went by this humble bed design grew into a variety of styles. 
          Today we have different types of beds that you can choose from. This guide gives you the lowdown on everything you need to know about bed varieties, be it king size bed box type bed, bed with sliders, beds for boys or beds for girls and much more.
        </p>

        <h4>A World Full Of Beds For Bedrooms</h4><br/>
            <p>Let’s take a look at the different types of bed that are available today.</p><br/>

            <h5>Murphy Bed</h5><br/>
              <p>
                Murphy beds are also known as wall beds and are one of the most intelligent types of bed design as they can be pushed back into the wall when not in use.  These types of beds are the best option for homeowners with limited space in an apartment or live in a small home. If you want to save some floor space, then a murphy bed is your go-to bed without a shadow of doubt!
              </p>
              <img src={murphybeddesign} style={{width:'100%'}} alt=''/><br/><br/><br/>

            <h5>Trundle Bed</h5><br/>
              <p>
                A trundle is a low bed which can be pulled out or rolled out from the parent bed or bed with sliders. This bed is apt when you have a lot of visitors or friends who need space to bunk. It can also be used in children’s bedrooms if the room is small.
              </p>
              <img src={trundlebed} style={{width:'100%'}} alt=''/><br/><br/><br/>

            <h5>Bunk Beds</h5><br/>
              <p>
                These are the most popular choice when thinking of  beds for children’s rooms. These beds are designed one over another and are equipped with a ladder to reach the top. Also, great for small homes or bedrooms as they take up less floor space.
              </p>
              <img src={bunkbeds}  style={{width:'100%'}} alt=''/><br/><br/><br/>

            <h5>Hydraulic Beds</h5><br/>
              <p>
                This box type bed design has a lift-up mechanism and is built to provide storage beneath. For those of you who need extra storage, this is a good choice. Ideal if you have a lot of stuff or are in a small bedroom/ home.
              </p>
              <img src={hydraulic} style={{width:'100%'}} alt=''/><br/><br/><br/>

            <h5>Floor Beds</h5><br/>
              <p>
                Floor beds are often called futons that are nothing but padded mattresses and are easy to roll up. Floor beds are smart folding type beds that can be used in a child bedroom as they are safe and allow free movement. 
                Also great for studio apartments or rooms used by one person only.
              </p>
              <img src={floorbeds} style={{width:'100%'}} alt=''/><br/><br/><br/>

            <h5>Storage Beds</h5><br/>
              <p>
                These days beds with storage can be a double, single, queen, king size bed which have storage either to lift up or in the form of drawer type bed.
              </p>
              <img src={storagebeddesign} style={{width:'100%'}} alt=''/><br/><br/><br/>


        <h4>Types Of Beds And Their Sizes</h4><br/>

            <h5>King Size Bed</h5><br/>
              <p>
                A king-size bed is a bed that is the largest-sized bed so far. It measures 76” X 80”  This bed is generally found in the master bedroom.
              </p>
              <img src={kingsizebed}  style={{width:'100%'}} alt=''/><br/><br/><br/>

            <h5>Queen Size Bed</h5><br/>
              <p>
                Queen size bed is smaller compared to the king-size and measures 60” X 80” This bed can be found in guest rooms, children’s rooms, grandparents rooms.
              </p>
              <img src={queensizebed} style={{width:'100%'}} alt=''/><br/><br/><br/>

            <h5>Single Bed</h5><br/>
              <p>
                This is a bed which only one person can sleep in. As the name suggests it’s for only one person.
              </p>
              <img src={singlebeddesign} style={{width:'100%'}} alt=''/><br/><br/><br/>
            

          <h4>All You Need To Know About Headboards</h4><br/>

              <h5>Bookcase Headboards</h5><br/>
                <p>
                  Types of headboards are designs for people who love to read. Bookcase headboards are designed so that you have enough space to store away all your books. 
                  Turn your bed frames with headboard into a bookshelf to create your own library.
                </p>

                <img src={bookcaseheadboards}  style={{width:'100%'}}  alt=''/><br/><br/><br/>

              <h5>Contemporary Headboards</h5><br/>
                <p>
                  These are headboards that are simple and sleek in their style, often seen in a single colour with a soft finish either in silk, wool or linen. 
                  So if you like a clean yet sophisticated look this headboard is for you.
                </p>
                <img src={contemporaryheadboards}  style={{width:'100%'}}  alt=''/><br/><br/><br/>

              <h5>Slat Headboards</h5><br/>
                <p>
                  These types of headboards are made with either wood or metal. Vertical slat spindles are placed neatly in order to create this look.
                  The slats can be arranged as per your preference and colour.
                </p>
                <img src={slatheadboards} style={{width:'100%'}}  alt=''/><br/><br/><br/>

              <h5>Panel Headboards</h5><br/>
                <p>
                  These types of headboards go by their name and are designed in order to create the look. The panels are either vertical or horizontal and are made of a fabric finish.
                  Three-panel headboards are a popular pick with homeowners these days.
                </p>
                <img src={panelheadbords}  style={{width:'100%'}} alt=''/><br/><br/><br/>

              <h5>Traditional Headboards</h5><br/>
                <p>
                  These types of headboards are usually attached to the bed and are made from rich wood to give it an authentic traditional look.
                </p>
                <img src={traditionalheadboards } style={{width:'100%'}} alt=''/><br/><br/><br/>

              <h5>Wooden Headboards</h5><br/>
                <p>
                  Wood headboards can be customised as per your choice. You can have a storage integrated into your headboard in wood where all your favourite stories can be kept safe and within easy reach.
                </p>
                <img src={woodenheadboards} style={{width:'100%'}} alt=''/><br/><br/><br/>

              <h5>Metal Headboard</h5><br/>
                <p>
                  These types of headboards get their origins from the Victorian eras and are known to be strong,
                  durable and long-lasting. If you don’t have any plans on switching beds too often and want something that will last pretty much forever, then this is a perfect pick.
                </p>
                <img src={metalheadboards} style={{width:'100%'}}  alt=''/><br/><br/><br/>
              
              <h5>Natural Fibers (Wicker, Rattan) Headboard</h5><br/>
                <p>
                  If you like something a tad different and not mundane then these types of headboard could be something you like. These headboards use woven organic material like seagrass, abaca, wicker,
                  or rattan to give it an one of a kind classy yet country style look.
                </p>
                <img src={neutralfiber}  style={{width:'100%'}} alt=''/><br/><br/><br/>

              <h5>Leather Headboard</h5><br/>
                <p>
                  A bed headboard in leather is for those who feel the need to go beyond the usual to bring a rich and luxurious look to their space.
                  Authentic leather headboards often use hides of various animals. However, with a growing population of environmentally and ethically conscious people we have false leather which will do just the job of real leather as an ethical alternative.
                </p>
                <img src={leatherheadboard}  style={{width:'100%'}}  alt=''/><br/><br/><br/>

          <h4>Materials And Finishes For Beds</h4> <br/>
            <p>
              Types of bed frames are important as they change the entire way your bedroom looks. Let’s take a deeper look in materials and finishes that are used for beds.
            </p> <br/>
            <p>We at Artical Art use plywood as the core material for beds.</p><br/>

              <h5>What Is Plywood?</h5><br/>
                <p>Plywood is made of thin wooden layers which are put together or stuck together by a strong adhesive. The beds are coated with finishes of either veneer or an acrylic coat.</p><br/>

              <h5>The Most Creative Beds For Kids</h5><br/>
                <p>
                  <ul style={{lineHeight:"30px"}}>
                    <li>If you have kids who are full of fun and love jumping about going on adventures, then bunk beds with slides will brighten up their day</li>
                    <li>If you have a little princess residing in your home, then a castle bunk bed with a slide is sure to make her majestic journey a blissful one</li>
                    <li> A treehouse bunk bed is sure to be loved by your child whether its a girl or a boy. A tree concept will make them enter into an imaginary world</li>
                  </ul>
                </p><br/>

         <h4>FAQs on Beds</h4><br/>
           <p>
            Here are some commonly asked questions which we at Artical Art would like to address so you can make your choice smarter and wiser.
          </p><br/>

            <h5>1. What age can a child go to sleep on the top level of a bunk bed?</h5><br/>
              <p>
                Generally, if your child is below nine years of age, he or she should not be allowed to sleep on the top bunk for safety reasons. These days bunk beds come with an advisory manual as there are a variety of bunk beds and can also be custom made.
              </p><br/>

            <h5>2. What is a headboard for bed?</h5><br/>
              <p>
                Headboards provide support, so you lean up against them while reading a book watching a movie or simply just resting and chatting. Headboards also add to the overall aesthetics of your beds.
                There are headboards that come with storage for people who love to read and need space to store away books. Headboards also prevent stains on your walls. So there you are, these are some reasons a bed headboard will do you good.
              </p><br/>

            <h5>3. What type of bed is the most sturdy?</h5><br/>
              <p>
                Metal or steel bed frames are considered durable and long-lasting as they don’t wither away like wood. So if you want something to last you decades, then metal frames are your go option.<br/>

                We hope this guide gave you an insight into all about beds. Choosing the right bed is an important part of interior design for bedrooms. Read this blog to know more about it. And if you have any questions on insights send us an email.
              </p>  <br/><br/><br/>

        {/* end of  all about beds */}

        {/* ************************************************** */}

        <h1 id='bedroom4'>A Guide To Wardrobe Designs For Different Types Of Bedrooms</h1><br/>
        <p>
          We have all dreamed of owning stylish wardrobes just like celebrities do. Who wouldn’t want something that looks like it’s straight out of a magazine. Before you get inspired to design yours first decide the bedroom it’s going to be placed in.
        </p><br/>

        <p>
          There are several types of wardrobes you can design today based on your individual requirements and the type and size of the bedroom it will be placed in. However, one thing that is common, irrespective of the bedroom it is used in, is that wardrobes are frequently used. And every bedroom in your house needs a wardrobe that is easy to access, offers ample storage space, 
          and blends in with the overall interior design of your bedroom.
        </p><br/>

        <p>
          Before selecting a wardrobe for any bedroom of your house you must first narrow down your choices to either a freestanding wardrobe or a built-in wardrobe. The advantage of freestanding wardrobes is that they can be easily carried to another bedroom or a new home in case you move.
        </p><br/>

        <p>
          Another option is to design a built-in wardrobe. While built-in wardrobes are not movable the biggest benefit here is that you get to customise and personalise it in terms of materials, size, colours and accessories to match your style and requirements.
        </p><br/>
        <img src={wardrobedesigninbedrom} style={{width:'100%'}} alt=''/><br/><br/><br/>

        <h4>What Materials And Finishes Are Right For Wardrobes?</h4><br/>
          <p>
            The most important thing to consider while choosing or designing a wardrobe for any bedroom is the materials and finishes. The idea is to design a sturdy wardrobe that can hold a lot of your stuff and look absolutely stunning at the same time. 
            Most interior designers will recommend using MDF (Medium Density Fibreboard), HDF (High-Density Fibreboard) or plywood. All of these materials are strong, durable and fit for wardrobes.
          </p><br/>
          <p>
            On the other hand, the list of finishes for wardrobes you can choose from is neverending. You can opt for laminates (matte and high gloss), veneers, acrylic, lacquered glass, or glass finishes as per your budget and taste.
            However, you must understand that every bedroom has a specific purpose attached to it and therefore interior design to suit the same. For instance, the master bedroom is usually the most stylish bedroom in any home. Therefore choose a wardrobe finish like veneer or lacquered glass to blend in well with the overall decor. A wardrobe with a laminate finish in a highly stylised bedroom may not be the smartest choice. Hence, choose your finishes wisely.
          </p><br/>
          <img src={wardrobedesign} style={{width:'100%'}} alt=''/><br/><br/><br/>

        <h4>What Are The Different Styles Of Wardrobes?</h4><br/>
          <p>
            Now let’s explore different styles of wardrobes for your bedroom so you can choose one to suit your lifestyle, taste and budget.
          </p><br/>

          <h5>A Wardrobe With Drawers And A Bookshelf</h5><br/>

            <i><b>Best fit for –</b>Master Bedroom In Medium Or Small Apartments</i><br/><br/>
            <p>
              This style of wardrobe with open storage such as a bookshelf and a drawer is a great way of making the best use of your space. It combines the necessity of a bookshelf with the functionalities of a wardrobe into one clean, elegant solution. The finish used here is white and blue laminate for the open bookshelf in line with the colour scheme of this bedroom. The drawers and shutters on this wardrobe have been designed with handles making it simple to use.
            </p><br/>
            <img src={wardrobewithbookshelf} style={{width:'100%'}} alt=''/><br/><br/><br/>

          <h5>A Sliding Door Wardrobe</h5><br/>
            <i><b>Best fit for </b>Small Bedrooms</i><br/><br/>
            <p>
              Sliding door wardrobes are the best fit for small rooms with limited space where it’s hard to access a swing door wardrobe. There are various sliding mechanisms like overlapping doors mechanisms or in-line door mechanisms to fit different budgets. The doors can be customised with a variety of finishes like laminates, lacquered glass, tinted mirrors, veneers, acrylic or frosted glass as shown in this image here.
            </p>
            <img src={slidingdoorwardrobe}  style={{width:'100%'}}  alt=''/><br/><br/><br/>

          <h5>Wardrobe With A Shoe Box And A Dresser</h5><br/>
            <i><b>Best fit for</b> a bedroom of Young Working Couple</i>

            <p>
              A simple swing door wardrobe with an open shoebox and a dresser unit, as we see in this image, is designed for working couples to ease their morning routines. This wardrobe design has a dedicated section to organise everything you need, literally from head to toe, and within arms reach of each other. 
              It is a perfect fit for a couple’s bedroom. This design is heavy on storage and can be further customised to blend in with your bedroom’s colour scheme and interior design style. High gloss laminate is used as the primary finish that makes it easy to clean and maintain nor does it scratch.
            </p>
            <img src={wardrobewithdresser}  style={{width:'100%'}} alt=''/><br/><br/><br/>

          <h5>A Shutter Wardrobe With A Study Unit</h5><br/>
            <i><b>Best fit for</b> a bedroom of Teenage Kids</i><br/><br/>
            <p>
              With an emphasis on maximum storage, this wardrobe has a no-frills design. It is simple yet striking with a bold wood grain laminate. It is designed with a study unit attached that has a small bookshelf above the desk to make the best use of the space. This style of wardrobe is an excellent choice if you are designing your teenager’s bedroom.
              Ample storage and a study unit are what your soon to be grown-up kids need
            </p>
            <img src={wardrobewithstudyunit} style={{width:'100%'}}  alt=''/><br/><br/><br/>

          <h5>A Glass And Aluminium Shutter Wardrobe</h5><br/>
            <i><b>Best fit for a</b>Master Bedroom</i><br/><br/>

            <p>
              Tinted glass and wooden accents is a great way to add a touch of luxury into your bedroom. You also have an option of adding LED strip lights inside a wardrobe design like this. These wooden accents can either be laminates or veneers. In this image here we see a wardrobe with framing used in a soft-gold tone. You can opt for a different frame colour to blend with the overall aesthetics of your bedroom.
            </p>
            <img src={glassandaluminiumshutterwardrobe} style={{width:'100%'}} alt=''/><br/><br/><br/>

          <h5>A Wardrobe With Loft Storage</h5><br/>
            <i><b>Best fit for a</b>Guest Bedroom, Master Bedroom, Kids Bedroom</i><br/><br/>
            <p>
              Lofts are additional storage spaces available over your wardrobe. Lofts are used to store items that are not frequently used but cannot be disposed of either. They are also used to store seasonal items like winter bedding. They can be added on to both sliding and swing door wardrobes to store your luggage and seldom-used belongings.
            </p>
            <img src={loftstoragewardrobe} style={{width:'100%'}} alt=''/><br/><br/><br/>

            <h5>A Walk-in Wardrobe</h5><br/>
            <p>
              It’s safe to say that we all want one! Walk-in wardrobes are a design reserved for large bedrooms. They are typically designed as part of the bedroom floor plan. Walk-in wardrobes function as a dressing area too with chairs or seaters with a mirror designed into space.
            </p>
            <img src={walkinwardrobe} style={{width:'100%'}}  alt=''/><br/>
                <p>Broadly, there are two types of walk-in wardrobes:</p><br/>

                  <h5>Walk-in Wardrobe With Shutters</h5><br/>
                    <i><b>Best fit for a</b>Guest Bedroom, Master Bedroom, Kids Bedroom</i><br/><br/>
                    <p>This design works best for open walk-in wardrobes that have no door to enter it. This type of walk-in wardrobe keeps dust, moisture and insects from getting to your clothes and accessories. But if you have a sealed off air-conditioned bedroom, it shouldn’t be a major concern.</p>
                    <img src={wardrobewithshutters} style={{width:'100%'}}  alt=''/><br/><br/><br/>

                  <h5>Shutterless Walk-in Wardrobe</h5><br/>
                    <i><b>Best fit for a</b>Small Or Studio Apartment</i><br/><br/>
                    <p>
                      Bedrooms with a partition or a door can have a shutterless walk-in wardrobe for easy access and display. This is ideal for people who are always in a hurry to get ready like working professionals or young couples sharing a small bedroom.
                    </p>
                    <img src={wardrobewithoutshutter} style={{width:'100%'}} alt=''/><br/><br/><br/>
          

          <h4>How To Design The Ideal Walk-In Wardrobe For Your Master Bedroom?</h4><br/>
          <p>Here are five tips to design an ideal walk-in wardrobe for yourself:</p><br/>

              <h5>1. Add A His And Her Section</h5><br/>
                <p>
                  Most walk-in wardrobes are big enough to add multiple sections that can be designated to your partner and you.. You can customise each section to suit your requirement and taste.
                </p><br/>

              <h5>2. Make Use Of The Corners</h5><br/>
                <p>
                  Corners are often the most neglected spaces. Using the right accessory can offer you additional storage and display space such as a tie or belt holder or chest of tiny drawers if you have the space to match.
                </p><br/>

              <h5>3. Add Necessary Compartments</h5><br/>
                <p>
                  The idea is to go beyond the standard compartments by incorporating additional features like a pull-out mirror, a pull-out trouser rack, an accessory tray, a pivoting hanger rod, skirting drawers or a pull-out iron board.
                  </p><br/>

              <h5>4. Set The Mood With The Right Lighting</h5><br/>
                <p>
                  Walk-in wardrobes have a lot of scope to play with different types of lighting. Consider adding sconce lights, spotlights, cove lights, strip lights inside the sections or even a designer chandelier.
                </p><br/>

              <h5>5. Add A Comfortable Seater</h5><br/>
                <p>
                  An accent chair or a seater is an essential piece of furniture for a walk-in wardrobe considering it functions as a separate dressing area. Cushioned seaters can be designed to complement your wardrobe design and offer additional storage space at the same time
                .</p><br/>

          <h4>How To Choose The Right Wardrobe Based On The Bedroom Type?</h4><br/>
            <p>
              Not all wardrobes are made equal. They are specific to each use case depending upon the bedroom they are installed in. For instance, a master bedroom wardrobe is usually designed with multiple, complementary features while a guest bedroom wardrobe would be more simple, basic and minimalistic in its design. 
              Learn how to choose wardrobes for different bedroom types with our detailed lowdown below.
            </p>
            <img src={howtochooserightwardrobe}  style={{width:'100%'}}  alt=''/><br/><br/><br/>

              <h5>Wardrobes For Master Bedrooms</h5><br/>
                <p>
                  Wardrobes for master bedrooms are typically feature-rich with a host of accessories and add-ons. They are also big on space. There are several types of wardrobes to choose from for your master bedroom. Some of the most popular choices are a walk-in wardrobe, a wardrobe with a dresser, and a bi-fold shutter wardrobe as shown in this image.
                  These wardrobes are further customised with additional accessories like mirror pull-outs, an iron board pull-out, a pull-out dresser, and his and her section.
                </p>
                <img src={wardrobeformasterbedroom}style={{width:'100%'}}   alt=''/><br/><br/><br/>

              <h5>Wardrobes For Kids Bedrooms</h5><br/>
                <p>
                  Kids bedroom wardrobes are designed to be accessible, low on maintenance and high on storage. They are made with finishes such as laminates that are durable and easy to maintain. 
                  Wardrobes in kids’ bedrooms are usually paired with study units. An excellent example of which is a pull-out study table that is a part of the wardrobe as shown in this image here.
                </p>
                <img src={wardrobeforkids} style={{width:'100%'}} alt=''/><br/><br/><br/>

              <h5>Wardrobes For Guest Bedrooms</h5><br/>
                <p>
                  Guest bedroom wardrobes are the bare minimum in terms of features as they are not regularly used. Guest bedrooms are typically small in size and are usually designed with either a wardrobe or a TV unit attached. Hence, a multifunctional wardrobe with a TV unit is an excellent way to make the most of your bedroom space without compromising on either. 
                  you can also give your guests the privacy they need with all comforts under one roof.
                </p>
                <img src={wardrobbeforguestroom}  style={{width:'100%'}}  alt=''/><br/><br/><br></br>

    </div>
  )
}

export default BedroomGuide